import { useAxios } from "@sttedra_ui/framework";
import axios from "axios";

// #region Globals
const { base } = useAxios();
const timeout = 5000;
// #endregion

// #region Public functions
async function loginExternal(params) {
  try {
    const url = `/Login/external`;

    const response = await base.post(url, params, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

async function loginInternal(token) {
  try {
    let baseUrl = base.defaults.baseURL;

    if (baseUrl.endsWith("/")) {
      baseUrl = baseUrl.slice(0, -1);
    }

    const url = `${baseUrl}/Login/internal`;

    const response = await axios.post(
      url,
      {},
      {
        headers: { AzureAD: token },
        timeout,
      }
    );

    return response;
  } catch (err) {
    return err.response;
  }
}

async function sendRecoverEmail(email) {
  try {
    const url = `/Password/SendRecoverEmail`;

    const response = await base.post(url, email, { timeout });

    return response;
  } catch (err) {
    return err;
  }
}
// #endregion

// #region Private functions
// #endregion

export { loginExternal, loginInternal, sendRecoverEmail };
